let resolveBackendEndpoint = process.env.REACT_APP_API_URL || "";

export const BASE_URL_ENDPOINT_PATH = resolveBackendEndpoint;
